module.exports = __webpack_public_path__ + "img/022.394c4050.png";